<template>
  <nuttrema-layout-east-block>
    <nuttrema-layout-west-three-vertical>

      <div slot="top-left" class="top--left__link">
        <a :title="$t('label.back')" @click="onBackEvent">
          <i class="el-icon-arrow-left"></i>
        </a>
      </div>

      <div v-if="_has(meta, 'title')" slot="top-center" class="top--center__title">
        <span>{{ $t(_get(meta, 'title')) }}</span>
      </div>

      <template slot="center">
        <nuttrema-loader v-if="InstanceSubscriptionInvoiceDetails.fetching"></nuttrema-loader>
        <form-instance-invoice-details
           v-else
          :InvoiceDetails="InstanceSubscriptionInvoiceDetails"
          @submit="onFormSubmit"
          @cancel="onCancelEvent">
        </form-instance-invoice-details>
      </template>
    </nuttrema-layout-west-three-vertical>
  </nuttrema-layout-east-block>
</template>

<script>
import PageProps from 'components/mixins/page-props';

import NuttremaLayoutEastBlock from 'components/ui/layout/nuttrema-layout-east-block';
import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import FormInstanceInvoiceDetails from 'components/pages/professional/shared/instance-subscriptions/details/form-instance-invoice-details';

export default {
  name: 'page-instance-subscription-invoice-details',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: true,
      default: null,
    },
    invoiceID: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaLayoutEastBlock,
    FormInstanceInvoiceDetails,
    NuttremaLayoutWestThreeVertical,
  },
  computed: {
    InstanceSubscriptionInvoiceDetails() {
      return this.$store.getters.InstanceSubscriptionInvoiceDetails(this.invoiceID);
    },
  },
  methods: {
    onFormSubmit() {},
  },
  created() {
    this.$store.dispatch('GetInstanceSubscriptionInvoiceDetails', { subscriptionID: this.id, invoiceID: this.invoiceID });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearInstanceSubscriptionInvoiceDetails', { invoiceID: this.invoiceID });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/instance/subscriptions/details/page-instance-subscription-invoice-details.vue